/** @format */

import { Box, Divider, Drawer as MuiDrawer, IconButton } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import styled from '@emotion/styled';
import SidebarMenu from '../../Molecules/Sidebar/SidebarMenu';
import AppFilter from '../../Molecules/Sidebar/AppFilter';
import { useAppContext } from '../../../store/store.app';

export const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

function Sidebar() {
  const {
    appStore: { isDrawerOpen, userInfo },
    ...appCtx
  } = useAppContext();

  if (!userInfo) {
    return <></>;
  }

  const userDetails = JSON.parse(localStorage.getItem('USER_DETAILS'));

  return (
    <Drawer
      className="no-print"
      anchor="left"
      variant="permanent"
      open={isDrawerOpen}
      component="nav"
      sx={{ display: { xs: 'none', md: 'block' } }}
    >
      <DrawerHeader>
        <IconButton onClick={appCtx.toggleDrawer}>
          <ChevronLeft />
        </IconButton>
      </DrawerHeader>

      <Box id="nav-container">
        <SidebarMenu />
      </Box>
      <Divider />
      <Box sx={{ display: userDetails?.user_id === '72' ? 'none' : 'auto' }}>
        <AppFilter />
      </Box>
    </Drawer>
  );
}

export default Sidebar;
